import React from 'react';
import classNames from 'classnames';
import styles from './HighlightItem.module.scss';
import { HighlightItem } from '@repo/utils/models/HighlightItem';

export default function Subheader({ item }: { item: HighlightItem }) {
  return (
    <div className={classNames(styles.subheader, 'information')}>
      <span className="information-item">{item.displayType}</span>
      <span className="information-item">{item.displayDate}</span>
      {item.type != 'news' && item.displaySource && (
        <span className="information-item">{item.displaySource}</span>
      )}
    </div>
  );
}
